
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire73bb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire73bb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bV0pP", function(module, exports) {

$parcel$export(module.exports, "OLCS_ION_TOKEN", () => $8ad5571f7dcc7a1a$export$97f9922ccba1277f);
const $8ad5571f7dcc7a1a$export$97f9922ccba1277f = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI3ZWVhYmU0Mi1jNTZkLTQ3OGItYmUxYS00YTMyMDQyZTMwNDkiLCJpZCI6NjQ1LCJpYXQiOjE2MDYxMjE2OTF9.zQibbf5P0-moQ8KiV_K7KMtyLHbR-VlPghj8lyqWduU";

});


var $cc3xD = parcelRequire("cc3xD");

var $dpRHA = parcelRequire("dpRHA");

var $9DiKA = parcelRequire("9DiKA");

var $f3WAG = parcelRequire("f3WAG");

var $9jDAx = parcelRequire("9jDAx");

var $4mWlF = parcelRequire("4mWlF");

var $5DwXE = parcelRequire("5DwXE");

var $bV0pP = parcelRequire("bV0pP");
Cesium.Ion.defaultAccessToken = (0, $bV0pP.OLCS_ION_TOKEN);
const $88be8afb4af92ff4$var$ol2d = new (0, $5DwXE.default)({
    layers: [
        new (0, $4mWlF.default)({
            source: new (0, $9jDAx.default)()
        })
    ],
    controls: (0, $f3WAG.defaults)({
        attributionOptions: {
            collapsible: false
        }
    }),
    target: "map",
    view: new (0, $9DiKA.default)({
        center: (0, $dpRHA.transform)([
            25,
            20
        ], "EPSG:4326", "EPSG:3857"),
        zoom: 3
    })
});
const $88be8afb4af92ff4$var$ol3d = new (0, $cc3xD.default)({
    map: $88be8afb4af92ff4$var$ol2d
});
const $88be8afb4af92ff4$var$scene = $88be8afb4af92ff4$var$ol3d.getCesiumScene();
Cesium.createWorldTerrainAsync().then((tp)=>$88be8afb4af92ff4$var$scene.terrainProvider = tp);
$88be8afb4af92ff4$var$ol3d.setEnabled(true);
document.getElementById("enable").addEventListener("click", ()=>$88be8afb4af92ff4$var$ol3d.setEnabled(!$88be8afb4af92ff4$var$ol3d.getEnabled()));
document.getElementById("resolutionScale").addEventListener("change", (evt)=>$88be8afb4af92ff4$var$ol3d.setResolutionScale(Number.parseFloat(evt.target.value)));
function $88be8afb4af92ff4$var$scalingOptions() {
    const printValue = document.querySelector("#printValue").value;
    const canvas = $88be8afb4af92ff4$var$scene.canvas;
    const v = Math.min(canvas.width, canvas.height);
    switch(printValue){
        case "portrait":
            return (0, $cc3xD.computeRectangle)(canvas, v / 4, v / 2);
        default:
            return (0, $cc3xD.computeRectangle)(canvas, v / 2, v / 4);
    }
}
(0, $cc3xD.autoDrawMask)($88be8afb4af92ff4$var$scene, ()=>$88be8afb4af92ff4$var$scalingOptions().scaling);
window["takeScreenshot"] = async function() {
    const r = $88be8afb4af92ff4$var$scalingOptions();
    console.log(r);
    const value = await (0, $cc3xD.takeScreenshot)($88be8afb4af92ff4$var$scene, r);
    const img = new Image();
    /**
   * @type {HTMLCanvasElement}
   */ const canvas = $88be8afb4af92ff4$var$scene.canvas;
    img.src = value;
    img.width = r.width / (canvas.width / canvas.clientWidth);
    img.height = r.height / (canvas.height / canvas.clientHeight);
    document.body.append(img);
};


//# sourceMappingURL=print.482b6260.js.map
